import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';

export type MasterPageProps = {
    cookieWarning?: React.ReactNode;
    navigationBar?: React.ReactNode;
    iconFooter?: React.ReactNode;
    legalFooter?: React.ReactNode;
    children?: React.ReactNode;
};

export const MasterPage: React.FC<MasterPageProps> = ({
    cookieWarning,
    navigationBar,
    iconFooter,
    legalFooter,
    children,
}) => (
    <div className="o-root">
        {cookieWarning}
        {navigationBar}
        <main className="o-main">{children}</main>
        {iconFooter && (
            <ContentSection pageWrapSize="medium" altBackground={true}>
                {iconFooter}
            </ContentSection>
        )}
        {legalFooter}
    </div>
);
